  <template>
  <div class="min-h-screen bg-white flex">
    <div
      class="
        flex-1 flex flex-col
        justify-center
        py-12
        px-4
        sm:px-6
        lg:flex-none lg:px-20
        xl:px-24
      "
    >
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <jet-authentication-card-logo />

          <h2 class="mt-12 text-3xl font-extrabold text-light-blue-600">
            {{ t("title") }}
          </h2>
          <p class="mt-2">
            {{ t("subtitle") }}
          </p>
        </div>

        <div class="mt-8">
          <form @submit.prevent="submit" class="space-y-6">
            <ui-input
              :invalid="'email' in form.errors"
              :error="form.errors.email"
              type="email"
              autocomplete="email"
              :label="t('email')"
              v-model="form.email"
              autofocus
            >
            </ui-input>

            <ui-input
              :invalid="'password' in form.errors"
              :error="form.errors.password"
              type="password"
              autocomplete="current-password"
              :label="t('password')"
              v-model="form.password"
            >
            </ui-input>

            <div class="flex items-center justify-between">
              <label class="flex items-center">
                <jet-checkbox name="remember" v-model="form.remember" />
                <span class="ml-2 text-sm text-gray-600">{{
                  t("remember_me")
                }}</span>
              </label>

              <div class="text-sm">
                <Link
                  v-if="canResetPassword"
                  :href="route('password.request')"
                  class="
                    font-medium
                    text-light-blue-600
                    hover:text-light-blue-800
                  "
                >
                  {{ t("forgot_password") }}
                </Link>
              </div>
            </div>

            <ui-button
              type="submit"
              class="w-full flex justify-center"
              :disabled="form.processing"
            >
              {{ t("sign_in") }}
            </ui-button>
          </form>
        </div>

        <p class="text-xs text-gray-500 mt-6 text-right">
          {{ t("copyright", { year: new Date().getFullYear() }) }}
        </p>
      </div>
    </div>
    <div
      class="
        hidden
        lg:block
        relative
        w-0
        flex-1
        border-l-8 border-light-blue-600
      "
    >
      <img
        class="absolute inset-0 h-full w-full object-cover"
        src="https://images.pexels.com/photos/414837/pexels-photo-414837.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo";
import JetButton from "@/Jetstream/Button";
import JetInput from "@/Jetstream/Input";
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
import { useI18n } from "vue-i18n";

export default {
  components: {
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    canResetPassword: Boolean,
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: "",
        password: "",
        remember: false,
      }),
    };
  },

  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          remember: this.form.remember ? "on" : "",
        }))
        .post(this.route("login"), {
          onFinish: () => this.form.reset("password"),
        });
    },
  },
};
</script>

<i18n>
{
  "es": {
    "title": "Iniciar sesión",
    "subtitle": "Tus análisis ambientales rápidos y precisos",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "remember_me": "Recordarme",
    "forgot_password": "Olvidé mi contraseña",
    "sign_in": "Iniciar",
    "copyright": "©{year} Análisis Ambiental",
  }
}
</i18n>